import { useTranslator } from "@templafy/translation";
import { useEffect } from "react";
const useZodDefaults = (zod)=>{
    const translator = useTranslator();
    useEffect(()=>{
        const zodErrorMap = (issue)=>{
            switch(issue.code){
                case zod.ZodIssueCode.invalid_type:
                    return {
                        message: issue.received === zod.ZodParsedType.undefined ? translator.formErrorRequired() : translator.formErrorInvalidValue()
                    };
                case zod.ZodIssueCode.invalid_enum_value:
                    return {
                        message: translator.formErrorInvalidValue()
                    };
                case zod.ZodIssueCode.invalid_date:
                    return {
                        message: translator.formErrorNotDate()
                    };
                case zod.ZodIssueCode.invalid_string:
                    return {
                        message: translator.formErrorNotString()
                    };
                case zod.ZodIssueCode.too_small:
                    switch(issue.type){
                        case 'array':
                            return {
                                message: translator.formErrorMinItems({
                                    minItems: `${issue.inclusive ? issue.minimum : issue.minimum + 1}`
                                })
                            };
                        case 'string':
                            {
                                const minLength = issue.inclusive ? issue.minimum : issue.minimum + 1;
                                return {
                                    message: 1 === minLength ? translator.formErrorRequired() : translator.formErrorMinLength({
                                        minLength: `${minLength}`
                                    })
                                };
                            }
                        case 'number':
                            return {
                                message: translator.formErrorMinValue({
                                    min: `${issue.inclusive ? issue.minimum : issue.minimum + 1}`
                                })
                            };
                        case 'date':
                            return {
                                message: translator.formErrorMinDate({
                                    minDate: new Date(Number(issue.minimum))
                                })
                            };
                        default:
                            return {
                                message: translator.formErrorInvalidValue()
                            };
                    }
                case zod.ZodIssueCode.too_big:
                    switch(issue.type){
                        case 'array':
                            return {
                                message: translator.formErrorMaxItems({
                                    maxItems: `${issue.inclusive ? issue.maximum : issue.maximum - 1}`
                                })
                            };
                        case 'string':
                            return {
                                message: translator.formErrorMaxLength({
                                    maxLength: `${issue.inclusive ? issue.maximum : issue.maximum - 1}`
                                })
                            };
                        case 'number':
                            return {
                                message: translator.formErrorMaxValue({
                                    max: `${issue.inclusive ? issue.maximum : issue.maximum - 1}`
                                })
                            };
                        case 'date':
                            return {
                                message: translator.formErrorMaxDate({
                                    maxDate: new Date(Number(issue.maximum))
                                })
                            };
                        default:
                            return {
                                message: translator.formErrorInvalidValue()
                            };
                    }
                case zod.ZodIssueCode.custom:
                    return {
                        message: translator.formErrorInvalidValue()
                    };
                default:
                    return {
                        message: translator.formErrorInvalidValue()
                    };
            }
        };
        zod.setErrorMap(zodErrorMap);
    }, [
        translator,
        zod
    ]);
};
export { useZodDefaults };
